
import { Record, toString as toString_1, Union } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { sheetInfoOfJson, waveInfoOfJson, convertFromJSONConnection, convertFromJSONComponent, LoadedComponent, SavedWaveInfo, Connection, Component, portOrientation_, portOrder_, Port, sheetInfoToJson, waveInfoToJson, convertToJSONConnection, convertToJSONComponent, componentIdDecoder, componentIdEncoder, legacyTypesConvert, JSONWave_SavedWaveInfo_$reflection, JSONWave_SheetInfo_$reflection, JSONComponent_Connection_$reflection, JSONComponent_Component_$reflection, LegacyCanvas_LegacyConnection_$reflection, LegacyCanvas_LegacyComponent_$reflection } from "./CommonTypes.js";
import { record_type, int32_type, array_type, uint32_type, obj_type, union_type, class_type, option_type, tuple_type, list_type } from "../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { now, minValue } from "../fable_modules/fable-library-js.5.13.0/Date.js";
import { newGuid } from "../fable_modules/fable-library-js.5.13.0/Guid.js";
import { empty as empty_2, isEmpty as isEmpty_1, toList, ofList, map as map_2, tryFind, add } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { Auto_generateBoxedEncoder_437914C6, toString, bigint, uint64, int64 } from "../fable_modules/Thoth.Json.10.5.1/Encode.fs.js";
import { bigint as bigint_1, uint64 as uint64_1, int64 as int64_1 } from "../fable_modules/Thoth.Json.10.5.1/Decode.fs.js";
import { empty } from "../fable_modules/Thoth.Json.10.5.1/Extra.fs.js";
import { ExtraCoders } from "../fable_modules/Thoth.Json.10.5.1/Types.fs.js";
import { choose, iterate as iterate_1, length, exists, collect, ofArray, singleton, append, splitAt, empty as empty_1, cons, reverse, tail, head, isEmpty, map } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { toFail, printf, toText, replace as replace_1, concat } from "../fable_modules/fable-library-js.5.13.0/String.js";
import { Result_Map, FSharpResult$2 } from "../fable_modules/fable-library-js.5.13.0/Result.js";
import { replace } from "../fable_modules/fable-library-js.5.13.0/RegExp.js";
import { Convert_fromJson, Convert_serialize } from "./SimpleJson/Json.Converter.js";
import { createTypeInfo } from "./SimpleJson/TypeInfo.Converter.js";
import { SimpleJson_parseNative } from "./SimpleJson/SimpleJson.js";
import { warn } from "../Shared/Log.js";
import { defaultArg, value as value_7, some } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { comparePrimitives, stringHash, safeHash, structuralHash, compare, equals } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { forAll, truncate, map as map_1, iterate } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { StringModule_Concat } from "./EEExtensions.js";
import { fromZero } from "../fable_modules/fable-library-js.5.13.0/BigInt.js";
import { fill, copyTo, item as item_1, mapIndexed } from "../fable_modules/fable-library-js.5.13.0/Array.js";
import { max } from "../fable_modules/fable-library-js.5.13.0/Double.js";
import { Optic_Map, Optic_Map_op_HatPercent_Z1462312A } from "./Optics.js";
import { paramSlots_, compId_ } from "./ParameterTypes.js";
import { List_distinct } from "../fable_modules/fable-library-js.5.13.0/Seq2.js";
import { pToInt, cToInt } from "./Ids.js";
import { isDigit } from "../fable_modules/fable-library-js.5.13.0/Char.js";
import { parse } from "../fable_modules/fable-library-js.5.13.0/Int32.js";

/**
 * A saved sheet with its wave info left UNREAD: 'T is instantiated at obj, which parses
 * anything. This is the last resort of jsonStringToState, and it is what lets the saved
 * selection change shape without a legacy reader - a selection this version cannot
 * understand costs the selection, never the sheet.
 * 
 * Every variant that can carry wave info is mirrored, because any of them can be the one
 * that fails. Only the newest was, which meant an older save holding an unreadable
 * selection failed to load at all rather than losing it.
 */
export class JsonHelpers_SavedCanvasUnknownWaveInfo$1 extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CanvasWithFileWaveInfo", "CanvasWithFileWaveInfoAndNewConns", "NewCanvasWithFileWaveInfoAndNewConns", "NewCanvasWithFileWaveSheetInfoAndNewConns"];
    }
}

export function JsonHelpers_SavedCanvasUnknownWaveInfo$1_$reflection(gen0) {
    return union_type("Helpers.JsonHelpers.SavedCanvasUnknownWaveInfo`1", [gen0], JsonHelpers_SavedCanvasUnknownWaveInfo$1, () => [[["Item1", tuple_type(list_type(LegacyCanvas_LegacyComponent_$reflection()), list_type(LegacyCanvas_LegacyConnection_$reflection()))], ["Item2", option_type(gen0)], ["Item3", class_type("System.DateTime")]], [["Item1", tuple_type(list_type(LegacyCanvas_LegacyComponent_$reflection()), list_type(LegacyCanvas_LegacyConnection_$reflection()))], ["Item2", option_type(gen0)], ["Item3", class_type("System.DateTime")]], [["Item1", tuple_type(list_type(JSONComponent_Component_$reflection()), list_type(JSONComponent_Connection_$reflection()))], ["Item2", option_type(gen0)], ["Item3", class_type("System.DateTime")]], [["Item1", tuple_type(list_type(JSONComponent_Component_$reflection()), list_type(JSONComponent_Connection_$reflection()))], ["Item2", option_type(gen0)], ["Item3", option_type(JSONWave_SheetInfo_$reflection())], ["Item4", class_type("System.DateTime")]]]);
}

export class JsonHelpers_SavedInfo extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["CanvasOnly", "CanvasWithFileWaveInfo", "CanvasWithFileWaveInfoAndNewConns", "NewCanvasWithFileWaveInfoAndNewConns", "NewCanvasWithFileWaveSheetInfoAndNewConns"];
    }
}

export function JsonHelpers_SavedInfo_$reflection() {
    return union_type("Helpers.JsonHelpers.SavedInfo", [], JsonHelpers_SavedInfo, () => [[["Item", tuple_type(list_type(LegacyCanvas_LegacyComponent_$reflection()), list_type(LegacyCanvas_LegacyConnection_$reflection()))]], [["Item1", tuple_type(list_type(LegacyCanvas_LegacyComponent_$reflection()), list_type(LegacyCanvas_LegacyConnection_$reflection()))], ["Item2", option_type(JSONWave_SavedWaveInfo_$reflection())], ["Item3", class_type("System.DateTime")]], [["Item1", tuple_type(list_type(LegacyCanvas_LegacyComponent_$reflection()), list_type(LegacyCanvas_LegacyConnection_$reflection()))], ["Item2", option_type(JSONWave_SavedWaveInfo_$reflection())], ["Item3", class_type("System.DateTime")]], [["Item1", tuple_type(list_type(JSONComponent_Component_$reflection()), list_type(JSONComponent_Connection_$reflection()))], ["Item2", option_type(JSONWave_SavedWaveInfo_$reflection())], ["Item3", class_type("System.DateTime")]], [["Item1", tuple_type(list_type(JSONComponent_Component_$reflection()), list_type(JSONComponent_Connection_$reflection()))], ["Item2", option_type(JSONWave_SavedWaveInfo_$reflection())], ["Item3", option_type(JSONWave_SheetInfo_$reflection())], ["Item4", class_type("System.DateTime")]]]);
}

export function JsonHelpers_SavedInfo__get_getCanvas(self) {
    switch (self.tag) {
        case 1: {
            const c_1 = self.fields[0];
            return legacyTypesConvert(c_1[0], c_1[1]);
        }
        case 2: {
            const c_2 = self.fields[0];
            return legacyTypesConvert(c_2[0], c_2[1]);
        }
        case 3:
            return self.fields[0];
        case 4:
            return self.fields[0];
        default: {
            const c = self.fields[0];
            return legacyTypesConvert(c[0], c[1]);
        }
    }
}

export function JsonHelpers_SavedInfo__get_getTimeStamp(self) {
    switch (self.tag) {
        case 1:
            return self.fields[2];
        case 2:
            return self.fields[2];
        case 3:
            return self.fields[2];
        case 4:
            return self.fields[3];
        default:
            return minValue();
    }
}

export function JsonHelpers_SavedInfo__get_getWaveInfo(self) {
    switch (self.tag) {
        case 1:
            return self.fields[1];
        case 2:
            return self.fields[1];
        case 3:
            return self.fields[1];
        case 4:
            return self.fields[1];
        default:
            return undefined;
    }
}

export function JsonHelpers_SavedInfo__get_getSheetInfo(self) {
    switch (self.tag) {
        case 1:
            return undefined;
        case 2:
            return undefined;
        case 3:
            return undefined;
        case 4:
            return self.fields[2];
        default:
            return undefined;
    }
}

function JsonHelpers_withWaveInfoDropped(saved) {
    switch (saved.tag) {
        case 1:
            return new JsonHelpers_SavedInfo(/* CanvasWithFileWaveInfoAndNewConns */ 2, [saved.fields[0], undefined, saved.fields[2]]);
        case 2:
            return new JsonHelpers_SavedInfo(/* NewCanvasWithFileWaveInfoAndNewConns */ 3, [saved.fields[0], undefined, saved.fields[2]]);
        case 3:
            return new JsonHelpers_SavedInfo(/* NewCanvasWithFileWaveSheetInfoAndNewConns */ 4, [saved.fields[0], undefined, saved.fields[2], saved.fields[3]]);
        default:
            return new JsonHelpers_SavedInfo(/* CanvasWithFileWaveInfo */ 1, [saved.fields[0], undefined, saved.fields[2]]);
    }
}

export const JsonHelpers_extraCoder = (() => {
    let copyOfStruct, copyOfStruct_1, copyOfStruct_2, copyOfStruct_3;
    let extra_9;
    let extra_6;
    const extra_3 = new ExtraCoders((copyOfStruct = newGuid(), copyOfStruct), add("System.Int64", [int64, int64_1], empty.Coders));
    extra_6 = (new ExtraCoders((copyOfStruct_1 = newGuid(), copyOfStruct_1), add("System.UInt64", [uint64, uint64_1], extra_3.Coders)));
    extra_9 = (new ExtraCoders((copyOfStruct_2 = newGuid(), copyOfStruct_2), add("System.Numerics.BigInteger", [bigint, (path) => ((value_1_1) => bigint_1(path, value_1_1))], extra_6.Coders)));
    return new ExtraCoders((copyOfStruct_3 = newGuid(), copyOfStruct_3), add("Ids.ComponentId", [componentIdEncoder, componentIdDecoder], extra_9.Coders));
})();

/**
 * converts a live CanvasState to its file form: legacy-compatible component types, and
 * every integer id written as a decimal string.
 */
export function JsonHelpers_convStateToJC(compL, connL) {
    return [map(convertToJSONComponent, compL), map(convertToJSONConnection, connL)];
}

/**
 * Code to convert a CanvasState to a JSON string, does not work for bigints (I think).
 * A serialisation failure is an Error: it must never be written to the sheet's
 * .dgm file, which would overwrite the sheet with garbage.
 */
export function JsonHelpers_stateToJsonStringAt(time, cState, waveInfo, sheetInfo) {
    let option, option_1;
    try {
        return new FSharpResult$2(/* Ok */ 0, [replace(Convert_serialize(new JsonHelpers_SavedInfo(/* NewCanvasWithFileWaveSheetInfoAndNewConns */ 4, [JsonHelpers_convStateToJC(cState[0], cState[1]), (option = waveInfo, (option != null) ? waveInfoToJson(option) : undefined), (option_1 = sheetInfo, (option_1 != null) ? sheetInfoToJson(option_1) : undefined), time]), createTypeInfo(JsonHelpers_SavedInfo_$reflection())), "(\\d+\\.\\d\\d)\\d+", "$1")]);
    }
    catch (e) {
        return new FSharpResult$2(/* Error */ 1, [concat("JSON serialisation of the sheet failed, so it was not saved: ", e.message)]);
    }
}

/**
 * The ordinary save: stamped with the time it is written, which is what says which sheet
 * the user was last working on - see MenuHelpers.chooseWhichToOpen. A rewrite that is not
 * an edit of the user's, such as the id conversion a project open does, keeps the stamp it
 * read and goes through stateToJsonStringAt instead.
 */
export function JsonHelpers_stateToJsonString(state_, state__1, state__2) {
    const state = [state_, state__1, state__2];
    return JsonHelpers_stateToJsonStringAt(now(), state[0], state[1], state[2]);
}

/**
 * Code to convert a CanvasState to a JSON string, allowing bigints
 */
export function JsonHelpers_stateToJsonStringExperimental(cState, waveInfo, sheetInfo) {
    let value, option, option_1;
    const time = now();
    try {
        return new FSharpResult$2(/* Ok */ 0, [(value = (new JsonHelpers_SavedInfo(/* NewCanvasWithFileWaveSheetInfoAndNewConns */ 4, [JsonHelpers_convStateToJC(cState[0], cState[1]), (option = waveInfo, (option != null) ? waveInfoToJson(option) : undefined), (option_1 = sheetInfo, (option_1 != null) ? sheetInfoToJson(option_1) : undefined), time])), toString(0, Auto_generateBoxedEncoder_437914C6(JsonHelpers_SavedInfo_$reflection(), undefined, JsonHelpers_extraCoder, undefined)(value)))]);
    }
    catch (e) {
        return new FSharpResult$2(/* Error */ 1, [concat("JSON serialisation of the sheet failed, so it was not saved: ", e.message)]);
    }
}

/**
 * NB tryParseNativeAs, not tryParseAs. Both are SimpleJson and both end in the same
 * AST-to-value conversion; they differ only in how the AST is built. tryParseAs uses
 * Fable.Parsimmon parser combinators over the whole file and measured ~8x slower than the
 * native JSON.parse variant - 59ms against 7ms on a 108KB sheet - and this function tries
 * up to three types in turn, so it paid that cost more than once per sheet loaded.
 * The two were checked to agree on every demo sheet, for each of the three types below.
 */
export function JsonHelpers_jsonStringToState(jsonString) {
    let _arg;
    try {
        _arg = (new FSharpResult$2(/* Ok */ 0, [Convert_fromJson(SimpleJson_parseNative(jsonString), createTypeInfo(tuple_type(list_type(LegacyCanvas_LegacyComponent_$reflection()), list_type(LegacyCanvas_LegacyConnection_$reflection()))))]));
    }
    catch (ex) {
        _arg = (new FSharpResult$2(/* Error */ 1, [ex.message]));
    }
    if (_arg.tag === 1) {
        let matchValue;
        try {
            matchValue = (new FSharpResult$2(/* Ok */ 0, [Convert_fromJson(SimpleJson_parseNative(jsonString), createTypeInfo(JsonHelpers_SavedInfo_$reflection()))]));
        }
        catch (ex_1) {
            matchValue = (new FSharpResult$2(/* Error */ 1, [ex_1.message]));
        }
        if (matchValue.tag === 1) {
            let matchValue_1;
            try {
                matchValue_1 = (new FSharpResult$2(/* Ok */ 0, [Convert_fromJson(SimpleJson_parseNative(jsonString), createTypeInfo(JsonHelpers_SavedCanvasUnknownWaveInfo$1_$reflection(obj_type)))]));
            }
            catch (ex_2) {
                matchValue_1 = (new FSharpResult$2(/* Error */ 1, [ex_2.message]));
            }
            if (matchValue_1.tag === 1) {
                const str_1 = matchValue_1.fields[0];
                warn(`could not parse saved JSON (${jsonString.length} chars): ${str_1}`);
                return new FSharpResult$2(/* Error */ 1, [str_1]);
            }
            else {
                return new FSharpResult$2(/* Ok */ 0, [JsonHelpers_withWaveInfoDropped(matchValue_1.fields[0])]);
            }
        }
        else {
            return new FSharpResult$2(/* Ok */ 0, [matchValue.fields[0]]);
        }
    }
    else {
        return new FSharpResult$2(/* Ok */ 0, [new JsonHelpers_SavedInfo(/* CanvasOnly */ 0, [_arg.fields[0]])]);
    }
}

/**
 * Return a memoized version of funcToMemoize where.
 * Repeated calls with equivalent inputs return a stored result.
 * Inputs a, a' are deemed equivalent if keyFunc a = keyFunc a'.
 * Use this as well as LazyView etc, it has a different usage since it need not
 * have React output and comparison is via a key function.
 */
export function memoizeBy(keyFunc, funcToMemoize) {
    let lastKey = undefined;
    let lastValue = undefined;
    return (a) => {
        const newKey = some(keyFunc(a));
        if (equals(newKey, lastKey)) {
            return value_7(lastValue);
        }
        else {
            lastKey = newKey;
            const v = funcToMemoize(a);
            lastValue = some(v);
            return v;
        }
    };
}

const identityMemos = [];

export function memoizeByIdentity(funcToMemoize) {
    let last = undefined;
    void (identityMemos.push(() => {
        last = undefined;
    }));
    return (a) => {
        let matchResult, key_1, value_1;
        if (last != null) {
            if ((last[1], last[0] === a)) {
                matchResult = 0;
                key_1 = last[0];
                value_1 = last[1];
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return value_1;
            default: {
                const value_2 = funcToMemoize(a);
                last = [a, value_2];
                return value_2;
            }
        }
    };
}

/**
 * Empty every memoizeByIdentity memo, releasing whatever their keys and values hold on to.
 * 
 * Call where something large is discarded rather than replaced - a simulation being ended. Doing
 * so is always safe: a memo is only ever an answer that can be worked out again, so the cost of
 * emptying one that was still wanted is that it is filled again on the next call.
 */
export function clearIdentityMemos() {
    iterate((clear) => {
        clear();
    }, identityMemos);
}

/**
 * replace new lines in a string by ';' for easier debug printing of records using %A
 */
export function nocr(s) {
    return replace_1(s, "\n", ";");
}

export function shortPComp(comp) {
    const matchValue = comp.Type;
    if (matchValue.tag === 26) {
        const sc = matchValue.fields[0];
        return toText(printf("%s:Custom.%s.%A->%A"))(comp.Label)(sc.Name)(sc.InputLabels)(sc.OutputLabels);
    }
    else {
        return toText(printf("%s:%A"))(comp.Label)(comp.Type);
    }
}

/**
 * return initial n characters of a string
 */
export function sprintInitial(n, s) {
    return StringModule_Concat("", map_1((value) => value, truncate(n, s.split(""))));
}

export function assertThat(cond, msg) {
    if (!cond) {
        toFail(printf("what? assert failed: %s"))(msg);
    }
}

/**
 * Thread a state through `f` for each item in turn. The first Error stops the walk and is
 * returned; later items are not visited.
 */
export function ResultList_fold(f, state, items) {
    const walk = (state_1_mut, items_1_mut) => {
        walk:
        while (true) {
            const state_1 = state_1_mut, items_1 = items_1_mut;
            if (!isEmpty(items_1)) {
                const matchValue = f(state_1, head(items_1));
                if (matchValue.tag === 0) {
                    state_1_mut = matchValue.fields[0];
                    items_1_mut = tail(items_1);
                    continue walk;
                }
                else {
                    return new FSharpResult$2(/* Error */ 1, [matchValue.fields[0]]);
                }
            }
            else {
                return new FSharpResult$2(/* Ok */ 0, [state_1]);
            }
            break;
        }
    };
    return walk(state, items);
}

/**
 * Apply `f` to every item, collecting the results in order.
 */
export function ResultList_traverse(f, items) {
    return Result_Map(reverse, ResultList_fold((got, item) => Result_Map((value) => cons(value, got), f(item)), empty_1(), items));
}

/**
 * Apply `f` to every item for its effect only.
 */
export function ResultList_iter(f, items) {
    return ResultList_fold((unitVar, item) => f(item), undefined, items);
}

/**
 * The list of Oks, or the first Error.
 */
export function ResultList_sequence(results) {
    return ResultList_traverse((x) => x, results);
}

/**
 * Return 2^exponent.
 */
export function pow2(exponent) {
    return (1 << exponent) | 0;
}

/**
 * Set an element of the list at the specified position.
 * This function is slow: O(n). Do not use unless necessary.
 */
export function listSet(lst, item, idx) {
    const patternInput = splitAt(idx, lst);
    return append(patternInput[0], append(singleton(item), splitAt(1, patternInput[1])[1]));
}

/**
 * Crop a string to the specified length.
 * fromStart indicates whether you want the first <len> characters or the last
 * <len> characters.
 */
export function cropToLength(len, fromStart, str) {
    const matchValue = str.length <= len;
    if (matchValue) {
        return str;
    }
    else if (fromStart) {
        return str.slice(undefined, (len - 1) + 1) + "...";
    }
    else {
        return "..." + str.slice(str.length - len, str.length);
    }
}

export function getMemData(address, memData) {
    return defaultArg(tryFind(address, memData.Data), fromZero());
}

/**
 * Returns a new array with the elements at index i1 and index i2 swapped
 */
export function swapArrayEls(i1, i2, arr) {
    return mapIndexed((i, x) => {
        if (i === i1) {
            return item_1(i2, arr);
        }
        else if (i === i2) {
            return item_1(i1, arr);
        }
        else {
            return x;
        }
    }, arr);
}

export function testMatch(diffX, diffY, normRot) {
    let matchResult;
    switch (normRot) {
        case 0: {
            if (diffX >= 0) {
                matchResult = 0;
            }
            else if (diffX < 0) {
                matchResult = 1;
            }
            else {
                matchResult = 12;
            }
            break;
        }
        case 90: {
            if ((diffX >= 0) && (diffY >= 0)) {
                matchResult = 4;
            }
            else if ((diffX >= 0) && (diffY < 0)) {
                matchResult = 5;
            }
            else if ((diffX < 0) && (diffY >= 0)) {
                matchResult = 6;
            }
            else if ((diffX < 0) && (diffY < 0)) {
                matchResult = 7;
            }
            else {
                matchResult = 12;
            }
            break;
        }
        case 180: {
            if (diffX >= 0) {
                matchResult = 2;
            }
            else if (diffX < 0) {
                matchResult = 3;
            }
            else {
                matchResult = 12;
            }
            break;
        }
        case 270: {
            if ((diffX >= 0) && (diffY >= 0)) {
                matchResult = 8;
            }
            else if ((diffX >= 0) && (diffY < 0)) {
                matchResult = 9;
            }
            else if ((diffX < 0) && (diffY >= 0)) {
                matchResult = 10;
            }
            else if ((diffX < 0) && (diffY < 0)) {
                matchResult = 11;
            }
            else {
                matchResult = 12;
            }
            break;
        }
        default:
            matchResult = 12;
    }
    switch (matchResult) {
        case 0:
            return ofArray([1, 0, diffX, diffY, 0, 0, -1]);
        case 1:
            return ofArray([1, 0, 0, diffY, diffX, 0, -1]);
        case 2:
            return ofArray([1, 0, (diffX - (2 * 1)) / 2, diffY, (diffX - (2 * 1)) / 2, 0, 1]);
        case 3:
            return ofArray([1, diffY / 2, diffX - (2 * 1), diffY / 2, 0, 0, 1]);
        case 4:
            return ofArray([1, 0, (diffX - 1) / 2, diffY + 1, (diffX - 1) / 2, 0, 0, -1]);
        case 5:
            return ofArray([1, 0, diffX - 1, diffY + 1, 0, 0, 0, -1]);
        case 6:
            return ofArray([1, 0, 0, diffY + 1, diffX - 1, 0, 0, -1]);
        case 7:
            return ofArray([1, 0, 0, (diffY + 1) / 2, diffX - 1, (diffY + 1) / 2, 0, -1]);
        case 8:
            return ofArray([1, 0, diffX - 1, diffY - 1, 0, 0, 0, 1]);
        case 9:
            return ofArray([1, 0, (diffX - 1) / 2, diffY - 1, (diffX - 1) / 2, 0, 0, 1]);
        case 10:
            return ofArray([1, 0, 0, (diffY - 1) / 2, diffX - 1, (diffY - 1) / 2, 0, 1]);
        case 11:
            return ofArray([1, 0, 0, diffY - 1, diffX - 1, 0, 0, 1]);
        default:
            return ofArray([1, 0, 0, 0, 0, 0, 1]);
    }
}

/**
 * Crop a string to first n chars
 */
export function PrintSimple_crop(s) {
    return sprintInitial(3, s);
}

/**
 * print a component simply
 */
export function PrintSimple_pComponent(comp) {
    return `|${comp.Label}:${comp.Type} PIN=${map((p) => toString_1(p.Id), comp.InputPorts)} POut=${map((p_1) => toString_1(p_1.Id), comp.OutputPorts)}|`;
}

/**
 * Print a connection simply
 */
export function PrintSimple_pConnection(conn) {
    return `${conn.Source.Id}->${conn.Target.Id}`;
}

/**
 * human-readable print of CanvasState.
 */
export function PrintSimple_pState(_arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    return ((("\n-----COMPS-----\n" + StringModule_Concat("\n", map(PrintSimple_pComponent, _arg[0]))) + "\n\n-----CONNS----\n") + StringModule_Concat("\n", map(PrintSimple_pConnection, _arg[1]))) + "\n";
}

/**
 * Which integers are taken, one flag per value: assignment is a first-zero scan from a
 * cursor that only advances, so ids come out dense and seeding is one pass.
 */
export class IdAllocator_Allocator extends Record {
    constructor(Used, Cursor) {
        super();
        this.Used = Used;
        this.Cursor = (Cursor | 0);
    }
}

export function IdAllocator_Allocator_$reflection() {
    return record_type("Helpers.IdAllocator.Allocator", [], IdAllocator_Allocator, () => [["Used", array_type(uint32_type)], ["Cursor", int32_type]]);
}

/**
 * Allocators are cheap: sheet-scoped ones are made, seeded and dropped per operation.
 */
export function IdAllocator_makeAllocator(initialSize) {
    return new IdAllocator_Allocator(new Uint32Array(max(16, initialSize)), 1);
}

function IdAllocator_ensureSize(alloc, index) {
    if (index >= alloc.Used.length) {
        const bigger = new Uint32Array(max(2 * alloc.Used.length, index + 1));
        copyTo(alloc.Used, 0, bigger, 0, alloc.Used.length);
        alloc.Used = bigger;
    }
}

/**
 * Mark an id as taken. Sentinels (0 and below) are ignored.
 */
export function IdAllocator_reserve(alloc, id) {
    if (id > 0) {
        IdAllocator_ensureSize(alloc, id);
        alloc.Used[id] = 1;
    }
}

export function IdAllocator_isUsed(alloc, id) {
    if ((id > 0) && (id < alloc.Used.length)) {
        return item_1(id, alloc.Used) !== 0;
    }
    else {
        return false;
    }
}

/**
 * The smallest unused positive integer, marked taken as it is handed out.
 */
export function IdAllocator_next(alloc) {
    let i = max(1, alloc.Cursor);
    while ((i < alloc.Used.length) && (item_1(i, alloc.Used) !== 0)) {
        i = ((i + 1) | 0);
    }
    IdAllocator_ensureSize(alloc, i);
    alloc.Used[i] = 1;
    alloc.Cursor = ((i + 1) | 0);
    return i | 0;
}

export function IdAllocator_reset(alloc) {
    fill(alloc.Used, 0, alloc.Used.length, 0);
    alloc.Cursor = 1;
}

const IdAllocator_components = IdAllocator_makeAllocator(10000);

const IdAllocator_ports = IdAllocator_makeAllocator(40000);

const IdAllocator_connections = IdAllocator_makeAllocator(20000);

export function IdAllocator_resetAll() {
    IdAllocator_reset(IdAllocator_components);
    IdAllocator_reset(IdAllocator_ports);
    IdAllocator_reset(IdAllocator_connections);
}

/**
 * A fresh component id, unique across the open design.
 */
export function IdAllocator_newComponentId() {
    return IdAllocator_next(IdAllocator_components) | 0;
}

/**
 * A fresh port id. Unique across the design in practice (one allocator serves every
 * sheet), though only uniqueness within a sheet is required of it.
 */
export function IdAllocator_newPortId() {
    return IdAllocator_next(IdAllocator_ports) | 0;
}

/**
 * A fresh connection id; as newPortId, over-unique by construction.
 */
export function IdAllocator_newConnectionId() {
    return IdAllocator_next(IdAllocator_connections) | 0;
}

export function IdAllocator_reserveComponentId(_arg) {
    IdAllocator_reserve(IdAllocator_components, _arg);
}

export function IdAllocator_reservePortId(_arg) {
    IdAllocator_reserve(IdAllocator_ports, _arg);
}

export function IdAllocator_reserveConnectionId(_arg) {
    IdAllocator_reserve(IdAllocator_connections, _arg);
}

export function IdAllocator_componentIdUsed(_arg) {
    return IdAllocator_isUsed(IdAllocator_components, _arg);
}

function RegenerateIds_remapPort(compMap, portMap, port) {
    let id, id_1;
    return new Port((id = port.Id, defaultArg(tryFind(id, portMap), id)), port.PortNumber, port.PortType, (id_1 = port.HostId, defaultArg(tryFind(id_1, compMap), id_1)));
}

function RegenerateIds_remapSymbolInfo(portMap, info) {
    return Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, portOrder_)((table_1) => map_2((_arg, ids) => map((id_2) => {
        const id_3 = id_2;
        return defaultArg(tryFind(id_3, portMap), id_3);
    }, ids), table_1))(Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, portOrientation_)((arg_1) => ofList(map((tupledArg) => {
        let id_1;
        return [(id_1 = tupledArg[0], defaultArg(tryFind(id_1, portMap), id_1)), tupledArg[1]];
    }, toList(arg_1)), {
        Compare: (x, y) => (compare(x, y) | 0),
    }))(info));
}

function RegenerateIds_remapSlots(compMap, slots) {
    return ofList(map((tupledArg) => [Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, compId_)((id) => {
        const id_1 = id;
        return defaultArg(tryFind(id_1, compMap), id_1);
    })(tupledArg[0]), tupledArg[1]], toList(slots)), {
        Compare: (x, y) => (compare(x, y) | 0),
    });
}

function RegenerateIds_remapComp(compMap, portMap, comp) {
    let id, option_1, option_2;
    return new Component((id = comp.Id, defaultArg(tryFind(id, compMap), id)), comp.Type, comp.Label, map((port) => RegenerateIds_remapPort(compMap, portMap, port), comp.InputPorts), map((port_1) => RegenerateIds_remapPort(compMap, portMap, port_1), comp.OutputPorts), comp.X, comp.Y, comp.H, comp.W, (option_1 = comp.SymbolInfo, (option_1 != null) ? RegenerateIds_remapSymbolInfo(portMap, option_1) : undefined), (option_2 = comp.SlotInfo, (option_2 != null) ? RegenerateIds_remapSlots(compMap, option_2) : undefined));
}

function RegenerateIds_remapConn(compMap, portMap, connMap, conn) {
    let id;
    return new Connection((id = conn.Id, defaultArg(tryFind(id, connMap), id)), RegenerateIds_remapPort(compMap, portMap, conn.Source), RegenerateIds_remapPort(compMap, portMap, conn.Target), conn.Vertices);
}

/**
 * Apply id maps - component, port and connection ids are separate namespaces, so separate
 * maps - to a canvas: ids, host ids, symbol layout maps, parameter slots, endpoints.
 */
export function RegenerateIds_remapCanvasState(compMap, portMap, connMap, _arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    return [map((comp) => RegenerateIds_remapComp(compMap, portMap, comp), _arg[0]), map((conn) => RegenerateIds_remapConn(compMap, portMap, connMap, conn), _arg[1])];
}

function RegenerateIds_remapWaveInfo(compMap, wi) {
    let option_2;
    return new SavedWaveInfo(wi.SelectedWaves, wi.Radix, wi.WaveformColumnWidth, (option_2 = wi.SelectedRams, (option_2 != null) ? ofList(map((tupledArg) => {
        let id;
        return [(id = tupledArg[0], defaultArg(tryFind(id, compMap), id)), tupledArg[1]];
    }, toList(option_2)), {
        Compare: (x, y) => (compare(x, y) | 0),
    }) : undefined), wi.SelectedFRams, wi.WSConfig, wi.ClkWidth, wi.Cursor, wi.LastClk, wi.DisplayedPortIds);
}

/**
 * Apply id maps to everything a LoadedComponent holds: the canvas, the parameter slots and
 * the saved waveform selection, which live on the LoadedComponent rather than in its
 * CanvasState.
 */
export function RegenerateIds_remapLoadedComponent(compMap, portMap, connMap, ldc) {
    let option_3;
    let CanvasState;
    const tupledArg = ldc.CanvasState;
    CanvasState = RegenerateIds_remapCanvasState(compMap, portMap, connMap, tupledArg[0], tupledArg[1]);
    let LCParameterSlots;
    const mapping = Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, paramSlots_)((slots) => RegenerateIds_remapSlots(compMap, slots));
    const option_1 = ldc.LCParameterSlots;
    LCParameterSlots = ((option_1 != null) ? mapping(option_1) : undefined);
    return new LoadedComponent(ldc.Name, ldc.TimeStamp, ldc.FilePath, (option_3 = ldc.WaveInfo, (option_3 != null) ? RegenerateIds_remapWaveInfo(compMap, option_3) : undefined), CanvasState, ldc.InputLabels, ldc.OutputLabels, LCParameterSlots, ldc.Form, ldc.LoadedComponentIsOutOfDate, ldc.Description, ldc.IsTopSheet, ldc.ArrayInfo);
}

/**
 * Give every component, port and connection on a sheet fresh ids from the design's
 * allocators, rewriting every reference. Used when a sheet is copied into a project:
 * Import / Duplicate Sheet, and library component materialisation.
 */
export function RegenerateIds_regenerateSheetIds(ldc) {
    const patternInput = ldc.CanvasState;
    const comps = patternInput[0];
    const freshFor = (mint, ids) => ofList(map((id) => [id, mint()], List_distinct(ids, {
        Equals: equals,
        GetHashCode: (x) => (structuralHash(x) | 0),
    })), {
        Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
    });
    return RegenerateIds_remapLoadedComponent(freshFor(IdAllocator_newComponentId, map((comp) => comp.Id, comps)), freshFor(IdAllocator_newPortId, map((port) => port.Id, collect((comp_1) => append(comp_1.InputPorts, comp_1.OutputPorts), comps))), freshFor(IdAllocator_newConnectionId, map((conn) => conn.Id, patternInput[1])), ldc);
}

/**
 * Admit a sheet into the open design, re-minting what breaks an invariant: a component id
 * already used elsewhere in the design (component ids are design-unique), or any id that
 * is a sentinel or duplicated within the sheet (per-sheet uniqueness is every kind's
 * floor). Clean ids are reserved so later minting cannot collide with them. Returns the
 * sheet and whether anything had to change.
 */
export function RegenerateIds_admitSheet(ldc) {
    let ids, ids_1, ids_2;
    const patternInput = ldc.CanvasState;
    const comps = patternInput[0];
    const compIds = map((comp) => comp.Id, comps);
    const portIds = map((port) => port.Id, collect((comp_1) => append(comp_1.InputPorts, comp_1.OutputPorts), comps));
    const connIds = map((conn) => conn.Id, patternInput[1]);
    if ((((ids = compIds, exists((id) => (((arg00$0040) => (cToInt(arg00$0040) | 0))(id) <= 0), ids) ? true : (length(List_distinct(ids, {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    })) !== length(ids)))) ? true : ((ids_1 = portIds, exists((id_1) => (((arg00$0040_1) => (pToInt(arg00$0040_1) | 0))(id_1) <= 0), ids_1) ? true : (length(List_distinct(ids_1, {
        Equals: equals,
        GetHashCode: (x_1) => (safeHash(x_1) | 0),
    })) !== length(ids_1))))) ? true : ((ids_2 = connIds, exists((id_2) => (((_arg) => _arg)(id_2) <= 0), ids_2) ? true : (length(List_distinct(ids_2, {
        Equals: equals,
        GetHashCode: (x_2) => (safeHash(x_2) | 0),
    })) !== length(ids_2))))) {
        return [RegenerateIds_regenerateSheetIds(ldc), true];
    }
    else {
        iterate_1((arg00$0040_2) => {
            IdAllocator_reservePortId(arg00$0040_2);
        }, portIds);
        iterate_1((arg00$0040_3) => {
            IdAllocator_reserveConnectionId(arg00$0040_3);
        }, connIds);
        const compMap = ofList(choose((id_3) => {
            if (IdAllocator_componentIdUsed(id_3)) {
                return [id_3, IdAllocator_newComponentId()];
            }
            else {
                IdAllocator_reserveComponentId(id_3);
                return undefined;
            }
        }, compIds), {
            Compare: (x_3, y_3) => (compare(x_3, y_3) | 0),
        });
        if (isEmpty_1(compMap)) {
            return [ldc, false];
        }
        else {
            return [RegenerateIds_remapLoadedComponent(compMap, empty_2({
                Compare: (x_4, y_4) => (compare(x_4, y_4) | 0),
            }), empty_2({
                Compare: (x_5, y_5) => (compare(x_5, y_5) | 0),
            }), ldc), true];
        }
    }
}

/**
 * Open a design: reset the allocators and admit every sheet in read order, so the same
 * design gets the same ids each time it is opened. Returns the sheets and the names of any
 * whose ids had to change.
 */
export function RegenerateIds_admitDesign(ldcs) {
    IdAllocator_resetAll();
    const admitted = map(RegenerateIds_admitSheet, ldcs);
    return [map((tuple) => tuple[0], admitted), choose((tupledArg) => {
        if (tupledArg[1]) {
            return tupledArg[0].Name;
        }
        else {
            return undefined;
        }
    }, admitted)];
}

function tryIdInt(s) {
    if ((((s.length >= 1) && (s.length <= 9)) && (s[0] !== "0")) && forAll(isDigit, s.split(""))) {
        return parse(s, 511, false, 32);
    }
    else {
        return undefined;
    }
}

/**
 * Whether a saved sheet's ids are in the OLD form: uuids, written before ids were integers.
 * 
 * Loading such a sheet allocates integers for them, so what is then in memory is not what is on
 * disk - deterministically, so nothing is wrong with it, but the file keeps its uuids until
 * something writes it. Opening a project that can be written is where that is settled: see
 * MenuHelpers.convertProjectIdsOnDisk. One old id anywhere in the sheet is enough, since the
 * whole sheet is rewritten either way.
 */
export function jsonCanvasHasOldIds(_arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    const isOld = (id) => (tryIdInt(id) == null);
    if (exists((comp) => {
        if (isOld(comp.Id)) {
            return true;
        }
        else {
            return exists((port) => isOld(port.Id), append(comp.InputPorts, comp.OutputPorts));
        }
    }, _arg[0])) {
        return true;
    }
    else {
        return exists((conn) => isOld(conn.Id), _arg[1]);
    }
}

/**
 * Convert one parsed sheet to in-memory form. The wave info needs no id mapping of its own: a
 * saved selection is label paths (see WavePath.fs). The mapping passed to waveInfoOfJson is for
 * the legacy SelectedRams field alone.
 */
export function sheetOfJson(canvas_, canvas__1, waveInfo, sheetInfo) {
    let option_4, option_6;
    const canvas = [canvas_, canvas__1];
    const jsonConns = canvas[1];
    const jsonComps = canvas[0];
    const makeMapping = (ids) => {
        const ids_1 = List_distinct(ids, {
            Equals: (x, y) => (x === y),
            GetHashCode: (x) => (stringHash(x) | 0),
        });
        const alloc = IdAllocator_makeAllocator(length(ids_1) + 1);
        iterate_1((id) => {
            const option_1 = tryIdInt(id);
            if (option_1 != null) {
                IdAllocator_reserve(alloc, option_1);
            }
        }, ids_1);
        const assigned = ofList(choose((id_2) => {
            const matchValue = tryIdInt(id_2);
            if (matchValue == null) {
                return [id_2, IdAllocator_next(alloc)];
            }
            else {
                return undefined;
            }
        }, ids_1), {
            Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
        });
        return (id_3) => {
            const matchValue_1 = tryIdInt(id_3);
            return ((matchValue_1 == null) ? defaultArg(tryFind(id_3, assigned), 0) : matchValue_1) | 0;
        };
    };
    const mapCompIdInt = makeMapping(map((comp) => comp.Id, jsonComps));
    const mapCompId = (arg) => (mapCompIdInt(arg) | 0);
    const mapPortIdInt = makeMapping(map((port) => port.Id, collect((comp_1) => append(comp_1.InputPorts, comp_1.OutputPorts), jsonComps)));
    const mapPortId = (arg_1) => (mapPortIdInt(arg_1) | 0);
    let mapConnId;
    const f1_2 = makeMapping(map((conn) => conn.Id, jsonConns));
    mapConnId = ((arg_2) => (f1_2(arg_2) | 0));
    return [[map((comp_2) => convertFromJSONComponent(mapCompId, mapPortId, comp_2), jsonComps), map((conn_1) => convertFromJSONConnection(mapConnId, mapCompId, mapPortId, conn_1), jsonConns)], (option_4 = waveInfo, (option_4 != null) ? waveInfoOfJson(mapCompId, option_4) : undefined), (option_6 = sheetInfo, (option_6 != null) ? sheetInfoOfJson(mapCompId, option_6) : undefined)];
}

export function isInput(_arg) {
    if (_arg.tag === 0) {
        return true;
    }
    else {
        return false;
    }
}

export function isOutput(_arg) {
    if (_arg.tag === 1) {
        return true;
    }
    else {
        return false;
    }
}

export function isViewer(_arg) {
    if (_arg.tag === 2) {
        return true;
    }
    else {
        return false;
    }
}

export function isCustom(_arg) {
    if (_arg.tag === 26) {
        return true;
    }
    else {
        return false;
    }
}

export function isIOLabel(_arg) {
    if (_arg.tag === 3) {
        return true;
    }
    else {
        return false;
    }
}

export function getCustomName(_arg) {
    if (_arg.tag === 26) {
        return _arg.fields[0].Name;
    }
    else {
        return toFail(printf("what? getCustomName should only be called with custom components"));
    }
}

export function getCustomComponentType(_arg) {
    if (_arg.tag === 26) {
        return _arg.fields[0];
    }
    else {
        return toFail(printf("what? getCustomComponentType should only be called with custom components"));
    }
}

